function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1006 8H14.8989C11.0949 8 8 11.095 8 14.8991V26.1008C8 29.905 11.0949 32.9999 14.8989 32.9999H26.1006C29.905 32.9999 32.9999 29.9049 32.9999 26.1008V14.8991C33 11.095 29.905 8 26.1006 8ZM30.7819 26.1008C30.7819 28.6819 28.6819 30.7817 26.1008 30.7817H14.8989C12.3179 30.7819 10.2181 28.6819 10.2181 26.1008V14.8991C10.2181 12.3181 12.3179 10.2181 14.8989 10.2181H26.1006C28.6818 10.2181 30.7817 12.3181 30.7817 14.8991V26.1008H30.7819Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4999 14.0583C16.9479 14.0583 14.0581 16.9481 14.0581 20.5002C14.0581 24.0521 16.9479 26.9417 20.4999 26.9417C24.052 26.9417 26.9418 24.0521 26.9418 20.5002C26.9418 16.9481 24.052 14.0583 20.4999 14.0583ZM20.4999 24.7235C18.1711 24.7235 16.2762 22.8289 16.2762 20.5C16.2762 18.171 18.1709 16.2763 20.4999 16.2763C22.8289 16.2763 24.7237 18.171 24.7237 20.5C24.7237 22.8289 22.8288 24.7235 20.4999 24.7235Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2119 12.1775C26.7846 12.1775 26.3648 12.3505 26.063 12.6536C25.7597 12.9553 25.5853 13.3753 25.5853 13.8041C25.5853 14.2316 25.7598 14.6514 26.063 14.9546C26.3646 15.2562 26.7846 15.4307 27.2119 15.4307C27.6408 15.4307 28.0593 15.2562 28.3624 14.9546C28.6655 14.6514 28.8386 14.2315 28.8386 13.8041C28.8386 13.3753 28.6655 12.9553 28.3624 12.6536C28.0607 12.3505 27.6408 12.1775 27.2119 12.1775Z",
  fill: "current"
});

function SvgIconInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.4f004541.svg";
export { ForwardRef as ReactComponent };